import { render, staticRenderFns } from "./PresentCard.vue?vue&type=template&id=0f47e28a&scoped=true&"
import script from "./PresentCard.vue?vue&type=script&lang=js&"
export * from "./PresentCard.vue?vue&type=script&lang=js&"
import style0 from "./PresentCard.vue?vue&type=style&index=0&id=0f47e28a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f47e28a",
  null
  
)

export default component.exports